import React, { useEffect, useState } from "react";

import { useGetTenantReports } from "hooks/useGetTenantReports";

import { PaginationTable } from "js/components/types";

import TenantReportsTablePresentation from "./TenantReportsTablePresentation";

interface TenantReportsTableForPersonalProps {
  showAdvisorColumn?: boolean;
  searchFilter?: string;
  additionalFilters?: {
    is_active?: string;
    status?: string;
    legal_type?: string;
  };
}

const TenantReportsTableForPersonal: React.FC<
  TenantReportsTableForPersonalProps
> = ({
  showAdvisorColumn = false,
  searchFilter = "",
  additionalFilters = {},
}) => {
  const [pagination, setPagination] = useState<PaginationTable>({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const { data, isPending } = useGetTenantReports({
    pagination,
    searchFilter,
    additionalFilters,
  });

  useEffect(() => {
    if (typeof data?.count === "number") {
      setPagination((prev) => ({
        ...prev,
        total: data.count,
      }));
    }
  }, [data?.count]);

  const handlePageChange = (page: number) => {
    setPagination((prev) => ({ ...prev, current: page }));
  };

  return (
    <TenantReportsTablePresentation
      data={data?.results || []}
      isLoading={isPending}
      pagination={pagination}
      onPageChange={handlePageChange}
      showAdvisorColumn={showAdvisorColumn}
    />
  );
};

export default TenantReportsTableForPersonal;
